import React from 'react';
import { Home, BookOpen, Target, Users } from './Icons';

const BottomNavigation = ({ 
  currentView, 
  onHomeClick, 
  onLearningClick, 
  onChallengeClick, 
  onSocialClick 
}) => {
  return (
    <div className="fixed bottom-0 left-0 right-0 bg-gray-900/90 backdrop-blur-sm border-t border-gray-700">
      <div className="flex justify-around items-center py-3">
        <button 
          className="flex flex-col items-center space-y-1 transition-all duration-200 ease-out hover:scale-110 active:scale-95"
          onClick={onHomeClick}
        >
          <Home className={`w-5 h-5 transition-colors ${currentView === 'home' ? 'text-blue-400' : 'text-gray-400'}`} />
          <span className={`text-xs transition-colors ${currentView === 'home' ? 'text-blue-400' : 'text-gray-400'}`}>首頁</span>
        </button>
        <button 
          className="flex flex-col items-center space-y-1 transition-all duration-200 ease-out hover:scale-110 active:scale-95"
          onClick={onLearningClick}
        >
          <BookOpen className={`w-5 h-5 transition-colors ${currentView === 'learning' ? 'text-blue-400' : 'text-gray-400'}`} />
          <span className={`text-xs transition-colors ${currentView === 'learning' ? 'text-blue-400' : 'text-gray-400'}`}>學習</span>
        </button>
        <button 
          className="flex flex-col items-center space-y-1 transition-all duration-200 ease-out hover:scale-110 active:scale-95"
          onClick={onChallengeClick}
        >
          <Target className={`w-5 h-5 transition-colors ${currentView === 'challenge' ? 'text-blue-400' : 'text-gray-400'}`} />
          <span className={`text-xs transition-colors ${currentView === 'challenge' ? 'text-blue-400' : 'text-gray-400'}`}>挑戰</span>
        </button>
        <button 
          className="flex flex-col items-center space-y-1 transition-all duration-200 ease-out hover:scale-110 active:scale-95"
          onClick={onSocialClick}
        >
          <Users className={`w-5 h-5 transition-colors ${currentView === 'social' ? 'text-blue-400' : 'text-gray-400'}`} />
          <span className={`text-xs transition-colors ${currentView === 'social' ? 'text-blue-400' : 'text-gray-400'}`}>社群</span>
        </button>
      </div>
    </div>
  );
};

export default BottomNavigation;
